// Role-based permission checker
// Template permissions are now controlled ONLY by roles, not user-level overrides

export const hasTemplatePermission = (userRole, permission) => {
  // Define which roles have which template permissions
  const rolePermissions = {
    'master_admin': {
      'templates.add': true,
      'templates.edit': true,
      'templates.delete': true,
      'templates.view': true
    },
    'MASTER_ADMIN': {
      'templates.add': true,
      'templates.edit': true,
      'templates.delete': true,
      'templates.view': true
    },
    'Administrator': {
      'templates.add': true,
      'templates.edit': true,
      'templates.delete': true,
      'templates.view': true
    },
    'admin': {
      'templates.add': true,
      'templates.edit': true,
      'templates.delete': true,
      'templates.view': true
    },
    'User Manager': {
      'templates.add': false,
      'templates.edit': false,
      'templates.delete': false,
      'templates.view': true
    },
    'User': {
      'templates.add': true,
      'templates.edit': true,
      'templates.delete': true,
      'templates.view': true
    },
    'user': {
      'templates.add': true,
      'templates.edit': true,
      'templates.delete': true,
      'templates.view': true
    },
    'SMS Operator': {
      'templates.add': false,
      'templates.edit': false,
      'templates.delete': false,
      'templates.view': true
    },
    'Report Viewer': {
      'templates.add': false,
      'templates.edit': false,
      'templates.delete': false,
      'templates.view': false
    },
    'Test': {
      'templates.add': false,
      'templates.edit': false,
      'templates.delete': false,
      'templates.view': false
    }
  };

  // Check if the role has the permission
  return rolePermissions[userRole]?.[permission] || false;
};

// Helper functions for specific template permissions
export const canAddTemplate = (userRole) => hasTemplatePermission(userRole, 'templates.add');
export const canEditTemplate = (userRole) => hasTemplatePermission(userRole, 'templates.edit');
export const canDeleteTemplate = (userRole) => hasTemplatePermission(userRole, 'templates.delete');
export const canViewTemplate = (userRole) => hasTemplatePermission(userRole, 'templates.view');
